import WifiOffIcon from '@mui/icons-material/WifiOff';

import { colors } from 'theme/colors';

import {
  OfflineNotificationContainer,
  OfflineNotificationInternalContainer,
  OfflineNotificationText,
  OfflineNotificationTitle,
} from './styles';

const OfflineNotification = (): React.ReactElement => (
  <OfflineNotificationContainer>
    <OfflineNotificationInternalContainer>
      <WifiOffIcon sx={{ color: colors.primary.main }} />

      <div>
        <OfflineNotificationTitle>You are offline</OfflineNotificationTitle>
        <OfflineNotificationText>Your submission will be saved and sent later.</OfflineNotificationText>
      </div>
    </OfflineNotificationInternalContainer>
  </OfflineNotificationContainer>
);

export default OfflineNotification;
